import React from 'react';
import DefaultLayout from '@presentation/layouts/DefaultLayout';
import About from '@presentation/pages/About/About';

const makeAbout = () => (
	<DefaultLayout>
		<About />
	</DefaultLayout>
);

export default makeAbout;
